// define rbr reducers.

import NotificationsConst from '../constants/notifications.constants';
import { removeDuplicated } from '../../utils/services';

const NotificationsReducers = (state = {}, action) => {
  switch (action.type) {
    case NotificationsConst.NOTIFICATIONS_LOAD_DATA:
      // console.log('load data', action.data);
      state = {
        ...state,
        data: [].concat(...action.data),
        isLoading: false
      };
      break;
    case NotificationsConst.NOTIFICATIONS_DELETE_ROW:
      state = {
        ...state,
        data: state.data.filter(val => val.data.id != action.item.data.id)
      };
      break;
    case NotificationsConst.NOTIFICATIONS_DELETE_ALL:
      state = {
        ...state,
        data: [],
        isLoading: false
      };
      break;
    case NotificationsConst.NOTIFICATIONS_ADD_NEW:
      state = {
        ...state,
        data: removeDuplicated(action.item.concat(state.data))
      };
      break;
    case NotificationsConst.NOTIFICATIONS_FILTER:
      state = {
        ...state,
        data: action.item
      };
      break;
    case NotificationsConst.NOTIFICATIONS_REACTION_EMOJI:
      const { notificationData, reacted_emojis = [] } = action.data;

      state = {
        ...state,
        data: state?.data?.map(row => {
          if (row.data.object_type == notificationData.object_type) {
            if (row.data.action_type == notificationData.action_type) {
              if (notificationData.action_type == 'single_metric_updated'
                  && row.data.emoji_data
                  && notificationData.emoji_data.obj_type == row.data.emoji_data.obj_type
                  && notificationData.emoji_data.obj_id == row.data.emoji_data.obj_id) {
                row.data.reacted_emojis = reacted_emojis;
              } else if ((notificationData.action_type == 'Comment' || notificationData.action_type == 'at_mention_goal')
                  && typeof row.data.show_emoji !== 'undefined' && row.data.show_emoji) {
                if ((typeof notificationData.metric_ds_data_id !== 'undefined' && notificationData.metric_ds_data_id && notificationData.metric_ds_data_id == row.data.metric_ds_data_id)
                   || (typeof notificationData.survey_data_id !== 'undefined' && notificationData.survey_data_id && notificationData.survey_data_id == row.data.survey_data_id)
                  || (typeof notificationData.metric_data_id !== 'undefined' && notificationData.metric_data_id && notificationData.metric_data_id == row.data.metric_data_id)
                  || (notificationData.action_id
                    && notificationData.action_id == row.data.action_id)) {
                  row.data.reacted_emojis = reacted_emojis;
                }
              }
            }
          }
          return row;
        })
      }
      break;
    default:
      break;
  }
  return state;
};

export default NotificationsReducers;
